/**
 * v-drag-scroll
 *
 * Permite navegar horizontalmente em um container com overflow segurando o
 * botão esquerdo do mouse e arrastando (como no toque do mobile).
 *
 * - O movimento é apenas horizontal (ajusta `scrollLeft`).
 * - Durante o arraste o cursor vira setas horizontais (`ew-resize`).
 * - Diferencia clique de arraste por um limite mínimo de deslocamento,
 *   evitando disparar cliques acidentais nos elementos das linhas.
 *
 * Uso: <div class="table-responsive" v-drag-scroll> ... </div>
 */

const DRAG_THRESHOLD = 5 // px mínimos para considerar arraste (e não clique)

const state = new WeakMap()

function hasOverflow(el) {
  return el.scrollWidth > el.clientWidth
}

function onMouseDown(el, event) {
  // Apenas botão esquerdo
  if (event.button !== 0) return
  if (!hasOverflow(el)) return

  const s = state.get(el)
  s.isDown = true
  s.dragging = false
  s.startX = event.pageX
  s.startScrollLeft = el.scrollLeft
}

function onMouseMove(el, event) {
  const s = state.get(el)
  if (!s.isDown) return

  const delta = event.pageX - s.startX

  if (!s.dragging && Math.abs(delta) < DRAG_THRESHOLD) return

  // Passou do limite: é um arraste
  if (!s.dragging) {
    s.dragging = true
    el.style.cursor = 'ew-resize'
    el.style.userSelect = 'none'
  }

  event.preventDefault()
  el.scrollLeft = s.startScrollLeft - delta
}

function endDrag(el) {
  const s = state.get(el)
  if (!s.isDown) return

  s.isDown = false
  el.style.userSelect = ''
  el.style.cursor = ''

  // Suprime o clique imediatamente posterior se houve arraste
  if (s.dragging) {
    s.suppressClick = true
    s.dragging = false
  }
}

function onClick(el, event) {
  const s = state.get(el)
  if (s.suppressClick) {
    s.suppressClick = false
    event.preventDefault()
    event.stopPropagation()
  }
}

export default {
  bind(el) {
    const handlers = {
      mousedown: (e) => onMouseDown(el, e),
      mousemove: (e) => onMouseMove(el, e),
      mouseup: () => endDrag(el),
      mouseleave: () => endDrag(el),
      click: (e) => onClick(el, e),
    }

    state.set(el, {
      isDown: false,
      dragging: false,
      suppressClick: false,
      startX: 0,
      startScrollLeft: 0,
      handlers,
    })

    el.addEventListener('mousedown', handlers.mousedown)
    document.addEventListener('mousemove', handlers.mousemove)
    document.addEventListener('mouseup', handlers.mouseup)
    el.addEventListener('mouseleave', handlers.mouseleave)
    // capture para interceptar antes dos handlers dos filhos
    el.addEventListener('click', handlers.click, true)
  },

  unbind(el) {
    const s = state.get(el)
    if (!s) return

    el.removeEventListener('mousedown', s.handlers.mousedown)
    document.removeEventListener('mousemove', s.handlers.mousemove)
    document.removeEventListener('mouseup', s.handlers.mouseup)
    el.removeEventListener('mouseleave', s.handlers.mouseleave)
    el.removeEventListener('click', s.handlers.click, true)

    state.delete(el)
  },
}
